import { zodResolver } from "@hookform/resolvers/zod";
import React, { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { z } from "zod";
import { ADD_PAYMENT_METHOD } from "../../../../../services/ApiCalls";
import { useNavigate } from "react-router-dom";
const schema = z.object({
  routingNumber: z
    .string()
    .trim()
    .min(1, { message: "Routing Number is required" }),
  accountNumber: z
    .string({
      required_error: "Account Number is required",
    })
    .min(1, { message: "Account Number is required" })
    .refine((data) => !isNaN(data), {
      message: "Account Number only contain a Numeric value",
    }),

  accountHolderName: z
    .string()
    .trim()
    .min(1, { message: "Account HolderName  is required" }),
  bankName: z.string().trim().min(1, { message: "Bank Name   is required" }),
});

const AddPaymentMethod = () => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
  });

  const onSubmit = async (data) => {
    try {
      const res = await ADD_PAYMENT_METHOD(data);
      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
        navigate("/setting/payment-method");
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  return (
    <>
      <section className="paymentMethod py-5 position-relative">
        <Container>
          <Row className="justify-content-center">
            <Col lg="5" sm="6" className="my-2">
              <div className="py-2 mb-3 head text-center">
                <h4 className="m-0 fw-sbold themeBlue">Payment Method</h4>
              </div>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <div className="py-2">
                  <input
                    type="text"
                    placeholder="Routing Number"
                    className="form-control"
                    {...register("routingNumber")}
                  />
                  {
                    <p className="errorColor">
                      {errors?.routingNumber && errors.routingNumber.message}
                    </p>
                  }
                </div>
                <div className="py-2">
                  <input
                    type="text"
                    placeholder="Account Number"
                    className="form-control"
                    {...register("accountNumber")}
                  />
                  {
                    <p className="errorColor">
                      {errors?.accountNumber && errors.accountNumber.message}
                    </p>
                  }
                </div>
                <div className="py-2">
                  <input
                    type="text"
                    placeholder="Account Holder Name"
                    className="form-control"
                    {...register("accountHolderName")}
                  />
                  {
                    <p className="errorColor">
                      {errors?.accountHolderName &&
                        errors.accountHolderName.message}
                    </p>
                  }
                </div>
                <div className="py-2">
                  <input
                    type="text"
                    placeholder="Bank Name"
                    className="form-control"
                    {...register("bankName")}
                  />
                  {
                    <p className="errorColor">
                      {errors?.bankName && errors.bankName.message}
                    </p>
                  }
                </div>
                <div className="py-2 ">
                  <div className="text-center px-md-5 mt-4">
                    <Button
                      className="d-inline-flex w-100 align-items-center justify-content-center commonBtn"
                      type="submit"
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddPaymentMethod;
